import UserHasPermissions from './../authorization/UserHasPermissions'
import RedirectIfAuthenticated from './../authorization/RedirectIfAuthenticated'

export default function middleware (router) {
	UserHasPermissions(router)
	RedirectIfAuthenticated(router)
}



// WEBPACK FOOTER //
// ./src/middleware/index.js